import type { ColumnDef } from '@tanstack/vue-table';

import type { PlatformUserRowFieldsFragment } from '@shared/api/graphql/gql/graphql';

import { getPlatformEmployeeStatusLabel } from './platform-registry';

type Membership = PlatformUserRowFieldsFragment['memberships'][number];

export function buildPlatformMembershipColumns<T>(select: (row: T) => Membership): ColumnDef<T>[] {
  return [
    {
      id: 'role',
      header: 'Роль',
      accessorFn: (row) => {
        const { employee } = select(row);
        return employee.is_owner ? 'Владелец' : employee.title || 'Сотрудник';
      },
    },
    {
      id: 'locations',
      header: 'Локации',
      accessorFn: (row) => {
        const membership = select(row);
        return membership.employee.is_owner || membership.locations.length === 0
          ? 'Все локации'
          : membership.locations.map(({ title }) => title).join(', ');
      },
    },
    {
      id: 'status',
      header: 'Статус',
      accessorFn: (row) => getPlatformEmployeeStatusLabel(select(row).employee.status),
    },
  ];
}
